var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.333h6m-12 0h1.116c.326 0 .49 0 .643-.037.136-.032.266-.086.385-.16.135-.082.25-.197.48-.428L13.5 4.333a1.414 1.414 0 10-2-2l-8.375 8.375c-.23.231-.346.346-.429.48-.073.12-.127.25-.16.386-.036.154-.036.317-.036.643v1.116z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgPencilIconWhite;